module.exports = __webpack_public_path__ + "img/activity_bg.3b9c203f.png";